export default __webpack_public_path__ + "static/media/settingsevents.d8044e0d.png";